<template>
  <div>
    <van-nav-bar
      title="产品库存"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />
    <van-search v-model="value" placeholder="请输入搜索关键词"      @search="tosearch"/>
	<table border="1" style="border-collapse: collapse;width: 100%;font-size: 14px;">
		<tr>
			<th style="width:40%;border: 1px solid #ffffff; padding: 4px;">产品</th>
			<th style="width:13%;border: 1px solid #ffffff; padding: 4px;">郑州</th>
			<th style="width:13%;border: 1px solid #ffffff; padding: 4px;">太原</th>
			<th style="width:13%;border: 1px solid #ffffff; padding: 4px;">总数</th>
			<th style="width:20%;border: 1px solid #ffffff; padding: 4px;">价格</th>
		</tr>
		<tr v-for="item in productdata" :key="item.id">
			<td style="width:40%;border: 1px solid #ffffff; padding: 4px;">{{item.name}}</td>
			<td style="width:13%;border: 1px solid #ffffff; padding: 4px;">{{item.zz_remaining_count}}</td>
			<td style="width:13%;border: 1px solid #ffffff; padding: 4px;">{{item.taiyuan_remaining_count}}</td>
			<td style="width:13%;border: 1px solid #ffffff; padding: 4px;">{{item.remaining_count}}</td>
			<td style="width:20%;border: 1px solid #ffffff; padding: 4px;">{{item.price_line}}</td>
			
		</tr>
		
		
	</table>
  </div>
</template>

<script>
  import * as Api from './api.js'

  export default {
    name: 'Main',
    data () {
      return {
        value:'',
        productdata:[],
		


      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
	  this.tosearch()
    },
    methods:{
      tosearch(){
        let query = {
          name:this.value,
          limit:999,

        }
        Api.getproducts(query).then(res=>{
          console.log(res)
          this.productdata = res.data.data

        })

      },
      onClickLeft(){
        this.$router.push({path:'/'})
      }

    }
  }

</script>

<style scoped>



</style>


// WEBPACK FOOTER //
// src/views/salerviews/products/index.vue